export const SET_IS_LOADING = 'setIsLoading';
export const setIsLoading = (loadingState) => ({
    type: SET_IS_LOADING,
    payload: loadingState,
});
